import { Link, useLocation } from "react-router-dom";
import { useGsbNavigation } from "@gsb-core/app-kit";
import { Compass } from "lucide-react";
import { brand } from "@gsb-core/brand";
import { Button } from "@gsb-core/react-components";
import { EmptyState, PageBody } from "@gsb-core/react-ui";
import { stripLanguagePrefix } from "./language-path";

export default function NotFound() {
  const { pathname } = useLocation();
  const { href } = useGsbNavigation();
  const insideDashboard =
    stripLanguagePrefix(pathname).startsWith("/dashboard");
  const target = insideDashboard ? "/dashboard" : "/";
  const targetLabel = insideDashboard
    ? "Back to dashboard"
    : `Back to ${brand.workspaceName}`;

  const body = (
    <EmptyState
      icon={Compass}
      title="Page not found"
      description={`This address is not part of ${brand.workspaceName}. It may have moved, or the link may be out of date.`}
      action={
        <Button asChild>
          <Link to={href(target)}>{targetLabel}</Link>
        </Button>
      }
    />
  );

  if (!insideDashboard) {
    return (
      <main className="flex min-h-screen items-center justify-center p-8">
        {body}
      </main>
    );
  }

  return <PageBody>{body}</PageBody>;
}
